module.exports = __webpack_public_path__ + "static/media/YourStoryOurStory-738x57px.d3eb7dd5.webp";